import { useMemo, useRef } from 'react';
import { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../utils/ContextProvider";
import Loader from "../Loader";
import './style.css'
import API from '../../utils/API';
import Swal from 'sweetalert2';
import SlideToggle from '../SlideToggle';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment'
import LiquidConsumptionLine from '../LiquidConsumptionLine';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { BrowserQRCodeReader } from '@zxing/browser';
import QrScanner from 'qr-scanner';
import QRCodeWithLabelAndLogo from '../QRCodeWithLabelAndLogo';
import { uploadAndScan } from '../../utils/utils';

const EquipmentTab = (props) => {

    const context = useContext(AppContext)
    const [devicePhotos, setDevicePhotos] = useState([])
    const location = useLocation();
    const [printQr, setPrintQr] = useState(false)
    const navigate = useNavigate();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const defaultAdding = useMemo(() => (
        {
            stage: 0,
            amount: 0,
            name: "",
            deleted: 0,
            inId: null

        }), []);

    useEffect(() => {
        if (!props.selectedChannel || !props.selectedChannel.id || !context.getUserInfo) return
        const cancelToken = API.cancelToken();
        API.getDevicePictures(cancelToken, props.selectedChannel.id).then(res => {
            setDevicePhotos(res.data)
        }).catch(err => {
            console.log(err)
            if (err.message === 'cancelling') return
            let message = 'Please try again later.'
            if (err.response && err.response.data && err.response.data.includes('error')) {
                message = err.response.data.error
            }
            Swal.fire({
                title: 'Error.',
                text: message,
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e',
            });

        })
    }, [props.selectedChannel, context.getUserInfo])

    const imgRef = useRef(null);

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            const imageDataUrl = e.target.result;
            const imgElement = imgRef.current;
            imgElement.onload = async () => {
                try {
                    const codeReader = new BrowserMultiFormatReader();
                    const result = await codeReader.decodeFromImageElement(imgRef.current);
                    updateChannel({ target: { name: "qr_id", value: result.getText() } })
                } catch (err) {
                    try {
                        const codeReader = new BrowserQRCodeReader();
                        const result = await codeReader.decodeFromImageUrl(imageDataUrl);
                        updateChannel({ target: { name: "qr_id", value: result.getText() } })
                    } catch (err) {
                        try {
                            const qrResult = await QrScanner.scanImage(file, {
                                returnDetailedScanResult: true,
                            });
                            updateChannel({ target: { name: "qr_id", value: qrResult.data } })
                        } catch (qrScannerErr) {
                            Swal.fire({
                                title: 'Oops!',
                                text: 'Could not detect code, please upload a picture with better contrast.',
                                icon: 'warning',
                                confirmButtonText: 'Ok',
                                confirmButtonColor: '#007b4e',
                            });
                        }
                    }
                }
            };
            imgRef.current.src = imageDataUrl;
        };

        reader.readAsDataURL(file);
    };


    function generateRandomString() {
        let length = 16
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const array = new Uint8Array(length);
        crypto.getRandomValues(array);

        for (let i = 0; i < length; i++) {
            result += chars[array[i] % chars.length];
        }

        updateChannel({ target: { name: "qr_id", value: result } })
    }

    const updateChannel = async (e) => {
        let { name, value, files } = e.target;

        if (name && name.includes('phase')) {
            let phase = name.split("_")[1]
            props.setSelectedChannel(prevValue => {
                return {
                    ...prevValue,
                    phases: { ...prevValue.phases, [phase]: value }
                }
            })
        } else if (name === 'images') {


            const selectedImages = await Promise.all(
                Array.from(files).map(file =>
                    new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = (e) => resolve({
                            name: file.name,
                            type: file.type,
                            size: file.size,
                            data: e.target.result
                        });
                        reader.readAsDataURL(file);
                    })
                )
            );
            if (selectedImages && selectedImages.length > 0) {
                props.setLoading(true)
                let uploadedUrls = await uploadAndScan(selectedImages)
                props.setSelectedChannel((prev) => ({
                    ...prev,
                    images: [...(prev.images ?? []), ...uploadedUrls],
                }));
                props.setLoading(false)
                return;
            }

        } else if (e.target.type === 'checkbox') {
            const { name, checked } = e.target;
            props.setSelectedChannel(prevValue => {
                return {
                    ...prevValue,
                    [name]: checked
                }
            })
        } else {
            props.setSelectedChannel(prevValue => {
                return {
                    ...prevValue,
                    [name]: value
                }
            })
        }
    }

    const handleSelectedChannel = (e) => {
        let link = queryParams.get('building') && queryParams.get('building') !== null && queryParams.get('building') !== "" ?
            `/device?device=${props.deviceData.device_id}&tab=equipment&channel=${e.currentTarget.value}&building=${queryParams.get('building')}` :
            `/device?device=${props.deviceData.device_id}&tab=equipment&channel=${e.currentTarget.value}}`
        navigate(link)
    }

    return (
        <div className='device'>
            <div className='min-h-[80vh]'>
                <div className='card tablet:p-8 mobile:p-3 min-h-[70vh] mb-6'>
                    <div className='input-border pb-8 items-center mb-6'>
                        <div className='flex flex-wrap w-full items-center justify-between'>
                            {props.getPutPost !== "get" &&
                                <input
                                    placeholder='Device ID'
                                    className='p-1 text-3xl p-2 outline-none hide-input-background laptop:w-3/12 tablet:w-full mobile:w-full'
                                    type="text"
                                    name='device_id'
                                    disabled={true}
                                    value={props.selectedChannel && props.selectedChannel.channel_name ? props.selectedChannel.channel_name : ""} />
                            }
                            {props.getPutPost === "get" &&
                                <select
                                    className='p-1 laptop:w-4/12 tablet:w-1/2 mobile:w-full mr-2 text-base input-color p-2 outline-none hide-input-background'
                                    name="channel_name"
                                    value={props.selectedChannel && props.selectedChannel.id ? props.selectedChannel.id : ""}
                                    onChange={handleSelectedChannel}>
                                    <option value="null">No Selection</option>
                                    {props.channelOptions && props.channelOptions.map((e, idx) => (
                                        <option key={idx + 'channeldata'} value={e.id}>{e.channel_name.trim()}</option>
                                    ))}
                                </select>
                            }
                            {
                                props.error && props.error.channel_name &&
                                <p className='text-red text-xs p-2'>{props.error.channel_name}</p>
                            }
                        </div>
                    </div>
                    {
                        props.loading &&
                        <Loader />
                    }
                    <div className='flex flex-wrap'>
                        <div className='input-border flex flex-wrap laptop:w-3/5 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                            <div className='w-full flex flex-wrap items-center'>
                                <label className='laptop:w-2/12 mobile:w-1/2 tablet:w-2/5 text-base input-label-color' >Category</label>
                                <select
                                    className='p-1 laptop:w-9/12 tablet:w-full mobile:w-full text-base input-color outline-none hide-input-background'
                                    name="category"
                                    disabled={props.getPutPost === 'get'}
                                    value={props.selectedChannel.category ? props.selectedChannel.category.trim() : ""}
                                    onChange={updateChannel}>
                                    <option value="null">No Selection</option>
                                    <option value="Cooling">Cooling</option>
                                    <option value="Ventilation">Ventilation</option>
                                    <option value="House Distribution">House Distribution</option>
                                    <option value="Lighting">Lighting</option>
                                    <option value="Source">Source</option>
                                    <option value="Slots & Gaming">Slots & Gaming</option>
                                    <option value="Heating">Heating</option>
                                    <option value="Risk Mitigation">Risk Mitigation</option>
                                    <option value="Distribution Point">Distribution Point</option>
                                    <option value="Riser Distribution">Riser Distribution</option>
                                    <option value="Revenue Stream">Revenue Stream</option>
                                    <option value="Refrigeration">Refrigeration</option>
                                    <option value="Tenant Power">Tenant Power</option>
                                    <option value="NGV Station">NGV Station</option>
                                    <option value="Water Supply & Conditioning">Water Supply & Conditioning</option>
                                    <option value="HVAC">HVAC</option>
                                    <option value="Mixed Use">Mixed Use</option>
                                    <option value="Plug Loads">Plug Loads</option>
                                    <option value="Capacitor Bank">Capacitor Bank</option>
                                    <option value=""></option>
                                    <option value="Building Distribution">Building Distribution</option>
                                    <option value="Industrial Equipment">Industrial Equipment</option>
                                    <option value="Building Level">Building Level</option>
                                    <option value="Elevator & Escalator">Elevator & Escalator</option>
                                    <option value="Process Equipment">Process Equipment</option>
                                    <option value="Medical Equipment">Medical Equipment</option>
                                    <option value="Pool Equipment">Pool Equipment</option>
                                    <option value="Battery Charging">Battery Charging</option>
                                    <option value="Audio Visual Equipment">Audio Visual Equipment</option>
                                    <option value="Servers">Servers</option>
                                    <option value="Tenant Suites">Tenant Suites</option>
                                </select>
                                {
                                    props.error && props.error.category &&
                                    <p className='text-red text-xs'>{props.error.category}</p>

                                }
                            </div>
                        </div>
                        {props.selectedChannel && props.selectedChannel.type !== 'water' && <div className='input-border flex flex-wrap laptop:w-2/5 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                            <div className='w-full flex flex-wrap items-center'>
                                <label className='laptop:w-4/12 mobile:w-1/2 tablet:w-2/5 text-base input-label-color' >Circuit Type</label>
                                <select
                                    className='p-1 laptop:w-4/12 tablet:w-1/2 mobile:w-full mr-2 text-base input-color p-2 outline-none hide-input-background'
                                    name="circuit_type"
                                    disabled={props.getPutPost === 'get'}
                                    value={props.selectedChannel.circuit_type ? props.selectedChannel.circuit_type.trim() : ""}
                                    onChange={updateChannel}>
                                    <option value="">No Selection</option>
                                    <option value="E">E</option>
                                    <option value="G">G</option>
                                    <option value="M">M</option>
                                    <option value="D">D</option>
                                    <option value="S">S</option>

                                </select>
                                {
                                    props.error && props.error.circuit_type &&
                                    <p className='text-red text-xs'>{props.error.circuit_type}</p>

                                }
                            </div>
                        </div>}
                    </div>
                    {props.selectedChannel && props.selectedChannel.type === 'electric' &&
                        <div className='flex flex-wrap'>
                            <div className='input-border flex flex-wrap laptop:w-1/3 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='laptop:w-4/12 mobile:w-1/2 tablet:w-2/5 text-base input-label-color' >Sub-Category</label>
                                    <input
                                        placeholder='Sub-Category'
                                        className='p-1 laptop:w-5/12 tablet:w-full mobile:w-full text-base input-color outline-none hide-input-background'
                                        type="text"
                                        name='sub_category'
                                        onChange={updateChannel}
                                        disabled={props.getPutPost === 'get'}
                                        value={props.selectedChannel.sub_category ? props.selectedChannel.sub_category : ""} />
                                    {
                                        props.error && props.error.sub_category &&
                                        <p className='text-red text-xs'>{props.error.sub_category}</p>

                                    }
                                </div>
                            </div>
                            <div className='input-border flex flex-wrap laptop:w-1/3 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='laptop:w-4/12 mobile:w-1/2 tablet:w-2/5 text-base input-label-color' >Equipment Group</label>
                                    <input
                                        placeholder='Equipment Group'
                                        className='p-1 laptop:w-5/12 tablet:w-full mobile:w-full text-base input-color outline-none hide-input-background'
                                        type="text"
                                        name='equipment_group'
                                        onChange={updateChannel}
                                        disabled={props.getPutPost === 'get'}
                                        value={props.selectedChannel.equipment_group ? props.selectedChannel.equipment_group : ""} />
                                    {
                                        props.error && props.error.equipment_group &&
                                        <p className='text-red text-xs'>{props.error.equipment_group}</p>

                                    }
                                </div>
                            </div>
                            <div className='input-border flex flex-wrap laptop:w-1/3 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='laptop:w-4/12 mobile:w-1/2 tablet:w-2/5 text-base input-label-color' >Equipment Model</label>
                                    <input
                                        placeholder='Equipment Model'
                                        className='p-1 laptop:w-5/12 tablet:w-full mobile:w-full text-base input-color outline-none hide-input-background'
                                        type="text"
                                        name='equipment_model'
                                        onChange={updateChannel}
                                        disabled={props.getPutPost === 'get'}
                                        value={props.selectedChannel.equipment_model ? props.selectedChannel.equipment_model : ""} />
                                    {
                                        props.error && props.error.equipment_model &&
                                        <p className='text-red text-xs'>{props.error.equipment_model}</p>

                                    }
                                </div>
                            </div>
                        </div>
                    }
                    <div className='flex flex-wrap'>
                        <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                            <div className='w-full flex flex-wrap items-center'>
                                <label className='laptop:w-2/12 mobile:w-1/2 tablet:w-2/5 text-base input-label-color'>End Use Location</label>
                                <input
                                    placeholder='End Use Location'
                                    className='p-1 laptop:w-7/12 tablet:w-full mobile:w-full text-base input-color outline-none hide-input-background'
                                    type="text"
                                    name='location'
                                    onChange={updateChannel}
                                    disabled={props.getPutPost === 'get'}
                                    value={props.selectedChannel && props.selectedChannel.location ? props.selectedChannel.location : ""} />
                                {
                                    props.error && props.error.location &&
                                    <p className='text-red text-xs'>{props.error.location}</p>

                                }
                            </div>
                        </div>
                    </div>
                    {props.selectedChannel && props.selectedChannel.type === 'electric' &&
                        <div className='flex flex-wrap'>
                            <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>

                                <div className='laptop:w-5/12 tablet:w-full mobile:w-full flex flex-wrap items-center'>
                                    <label className='w-2/5 text-base input-label-color' htmlFor="operating_load_threshold">Operating Load Threshold</label>
                                    <input
                                        placeholder='Operating Load Threshold'
                                        className='p-1 laptop:w-5/12 tablet:w-full mobile:w-full text-base input-color outline-none hide-input-background'
                                        type="number"
                                        name="operating_load_threshold"
                                        value={props.selectedChannel.operating_load_threshold ? props.selectedChannel.operating_load_threshold : ""}
                                        disabled={props.getPutPost === 'get'}
                                        onChange={updateChannel} />
                                    {
                                        props.error && props.error.operating_load_threshold &&
                                        <p className='text-red text-xs'>{props.error.operating_load_threshold}</p>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {props.selectedChannel && props.selectedChannel.type === 'electric' &&
                        <div className='flex flex-wrap'>

                            <div className='input-border flex flex-wrap w-full items-center mb-6'>
                                <SlideToggle titleClass="input-label-color mb-3" disabled={props.getPutPost === 'get'} setOptions={props.setSelectedChannel} options={props.selectedChannel} id="natural_gas_user" name="Natural Gas Consumption" />
                                <div className='w-full mb-5'>
                                    {
                                        props.selectedChannel && props.selectedChannel.natural_gas_user && props.selectedChannel.liquid_consumption ?
                                            props.selectedChannel.liquid_consumption.map((e) => (
                                                <LiquidConsumptionLine
                                                    index={"liquidconsumption" + e.id}
                                                    edit={props.getPutPost !== 'get'}
                                                    data={e}
                                                    selectedChannel={props.selectedChannel}
                                                    setSelectedChannel={props.setSelectedChannel}
                                                />
                                            ))
                                            :
                                            null
                                    }

                                    {props.selectedChannel && props.selectedChannel.natural_gas_user && props.getPutPost !== 'get' ?
                                        <LiquidConsumptionLine
                                            adding={true}
                                            data={defaultAdding}
                                            selectedChannel={props.selectedChannel}
                                            setSelectedChannel={props.setSelectedChannel}
                                        />
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {props.selectedChannel && props.selectedChannel.type === 'electric' &&
                        <div className='flex flex-wrap'>
                            <div className='input-border flex flex-wrap w-full items-center mb-6 pb-6'>
                                <SlideToggle titleClass="input-label-color" disabled={props.getPutPost === 'get'} setOptions={props.setSelectedChannel} options={props.selectedChannel} id="qr_active" name="QR/Bar Code:" />
                                <div className='flex flex-nowrap items-center justify-start w-full text-base input-label-color my-5'>
                                    <p className='mr-3'>Current Value: {props.selectedChannel.qr_id ? props.selectedChannel.qr_id : "N/A"}</p>
                                    <button className='text-[12px] px-2 border border-1 rounded-md' onClick={() => setPrintQr(!printQr)}>{printQr ? "Hide QR" : "View in QR Format"}</button>
                                </div>

                                {props.selectedChannel && props.selectedChannel.qr_active && props.getPutPost !== 'get' ?
                                    <div className='flex flex-nowrap items-center justify-start w-full text-base input-label-color mb-5'>
                                        <button onClick={generateRandomString} className='text-[12px] px-2 border border-1 rounded-md'>Generate Code</button>
                                        <p className='mx-4'>Or</p>
                                        <input
                                            className='mobile:w-1/2 tablet:w-7/12 ml-8 text-base input-color p-2 outline-none hide-input-background'
                                            type="file"
                                            name="image"
                                            onChange={handleImageUpload} />

                                    </div>
                                    :
                                    null
                                }
                                {
                                    props.selectedChannel && props.selectedChannel.qr_id && printQr &&
                                    <QRCodeWithLabelAndLogo
                                        value={props.selectedChannel.qr_id}
                                        label={props.selectedChannel.channel_name || 'Unknown Channel Name'}
                                    />
                                }
                            </div>
                        </div>
                    }


                    <img ref={imgRef} alt="preview" style={{ display: 'none' }} />

                    <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                        <label className='w-full text-base input-label-color mb-5' htmlFor="note">Notes</label>
                        {
                            props.getPutPost !== 'get' &&
                            <textarea
                                placeholder='Note'
                                className='p-1 w-full mobile:p-2 text-base input-color outline-none hide-input-background'
                                type="text"
                                name="note"
                                value={props?.selectedChannel?.note ? props.selectedChannel.note : ""}
                                disabled={props.getPutPost === 'get'}
                                onChange={updateChannel} />

                        }
                        {props.error && props.error.notes &&
                            <p className='text-red text-xs'>{props.error.notes}</p>}
                        <div className='max-h-[300px] overflow-y-auto w-full'>
                            {props.selectedChannel.notes && props.selectedChannel.notes.map((e, ix) => (
                                <div key={"notes" + ix} className='p-1 my-2 rounded-md w-full mobile:p-2 text-base input-color outline-none hide-input-background'>
                                    <h2 className='text-[12px] font-semibold text-[#B8BBB9] border-b' >{e.created_name} on {moment.utc(e.created_at).local().format('MMM D, YYYY h:mma')}:</h2>
                                    <p>{e.note}</p>
                                </div>
                            ))}

                        </div>
                    </div>
                    <div className='flex flex-wrap'>
                        <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                            <label className='w-1/12 text-base input-label-color'>Images</label>
                            <div className='w-10/12 flex flex-wrap items-center'>
                                <div className='flex flex-wrap w-full gap-2.5'>
                                    {
                                        props.getPutPost === 'get' && devicePhotos && devicePhotos.map((e, idx) => (
                                            <img key={idx + 'deviceimages'} className='w-20' src={e ? e : require('../../assets/images/placeholder-image.png')} alt="" />
                                        ))

                                    }
                                </div>
                                {props.getPutPost !== 'get' &&
                                    <input
                                        className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                        type="file"
                                        name="images"
                                        multiple
                                        onChange={updateChannel} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default EquipmentTab;